// Lazy-loader for the annotateX-js embed bundle served by the backend at
// /public/annotateX.js. The bundle self-registers `window.annotateX` and
// injects its stylesheet on load. Resolves with the global API object.

let loadPromise = null;

export function ensureAnnotateX() {
  if (typeof window === 'undefined') return Promise.reject(new Error('no window'));
  if (window.annotateX) return Promise.resolve(window.annotateX);
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    const done = () => (window.annotateX ? resolve(window.annotateX) : reject(new Error('annotateX failed to load')));
    const existing = document.getElementById('annotatex-js');
    if (existing) {
      existing.addEventListener('load', done);
      existing.addEventListener('error', reject);
      return;
    }
    const s = document.createElement('script');
    s.id = 'annotatex-js';
    s.src = '/public/annotateX.js';
    s.async = true;
    s.onload = done;
    s.onerror = reject;
    document.head.appendChild(s);
  });
  return loadPromise;
}
